export const getSum = (numArr) => {
  return (numArr.reduce((a, b) => a + b))
}